<template>
  <emd-text-content
    :title="$t('dueAt')"
    :content="dueAt"
  />
</template>

<script>
import { EmdTextContent } from 'emerald-vue/src/components'

export default {
  name: 'DueAtPaymentLinks',

  components: {
    EmdTextContent
  },

  props: {
    dueAt: {
      type: [String, Number],
      required: true
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "dueAt": "Data de vencimento"
    },
    "en-US": {
      "dueAt": "Due date"
    }
  }
</i18n>
